import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
import Paper from '@material-ui/core/Paper';
import AccessTime from "@material-ui/icons/AccessTime";

const useStyles = makeStyles(theme => ({
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    blankMessage: {
        padding: theme.spacing(2)
    },
    dense: {
        padding: theme.spacing(0, 1)
    },
    waitingColor: {
        backgroundColor: '#b0b0b0',
        color: 'white',
        fontWeight: '500'
    }
}));

export default function Message(props) {
    const {
        type,
        children,
        marginBottom = false,
        variant = 'filled',
        dense = false
    } = props;
    const classes = useStyles();

    switch (type) {
        case 'blank':
            return (
                <Paper className={classes.blankMessage}>
                    {children}
                </Paper>
            );
        case 'waiting':
            return (
                <Alert
                    variant={variant}
                    icon={<AccessTime fontSize="inherit" />}
                    classes={{ root: classes.waitingColor }}
                    className={clsx(marginBottom && classes.marginBottom, !!dense && classes.dense)}>
                    {children}
                </Alert>
            );
        default:
            return (
                <Alert
                    variant={variant}
                    severity={type}
                    className={clsx(marginBottom && classes.marginBottom, !!dense && classes.dense)}>
                    {children}
                </Alert>
            );

    }

    return type === 'blank' ? (
        <Paper className={classes.blankMessage}>
            {children}
        </Paper>
    ) : (
        <Alert
            variant={variant}
            severity={type}
            className={clsx(marginBottom && classes.marginBottom, !!dense && classes.dense)}>
            {children}
        </Alert>
    );
}

Message.propTypes = {
    type: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'waiting', 'blank']),
    marginBottom: PropTypes.bool,
    variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
    children: PropTypes.any,
    dense: PropTypes.bool
};